(function (root) {
  "use strict";

  var VISIBILITY_THRESHOLD = 0.5;
  var ELIGIBILITY_MSEC = 1000;
  var MILESTONES = [25, 50, 75, 90];

  function normalizeMediaUrl(value) {
    return String(value || "").split("#")[0].split("?")[0];
  }

  function logicalMediaKey(input) {
    input = input || {};
    return "product:" + (input.productId || "unknown") + ":media:" +
      (input.mediaId || normalizeMediaUrl(input.mediaUrl) || "unknown") + ":" +
      (input.context || "unknown");
  }

  function createMediaRegistry() {
    var viewed = {};
    return {
      markViewed: function (key) {
        if (viewed[key]) return false;
        viewed[key] = true;
        return true;
      },
      hasViewed: function (key) {
        return Boolean(viewed[key]);
      },
    };
  }

  function createVideoSession(options) {
    options = options || {};
    var durationSeconds = Number(options.durationSeconds) || 0;
    var emit = typeof options.emit === "function" ? options.emit : function () {};
    var playing = false;
    var visibleRatio = 0;
    var eligibleSince = null;
    var eligibleWatchMsec = 0;
    var reportedWatchMsec = 0;
    var playedSent = false;
    var milestones = {};
    var ended = false;

    function isEligible() {
      return playing && visibleRatio >= VISIBILITY_THRESHOLD && !ended;
    }

    function progressPercent() {
      if (!durationSeconds) return 0;
      return Math.min(100, (eligibleWatchMsec / (durationSeconds * 1000)) * 100);
    }

    function publishProgress() {
      var progress = progressPercent();
      for (var i = 0; i < MILESTONES.length; i += 1) {
        var milestone = MILESTONES[i];
        if (progress >= milestone && !milestones[milestone]) {
          milestones[milestone] = true;
          emit({ name: "product_video_progress", progress_percent: milestone, watch_time_msec: eligibleWatchMsec });
        }
      }
    }

    function accrue(now) {
      if (eligibleSince === null) return;
      var elapsed = Math.max(0, Number(now) - eligibleSince);
      eligibleWatchMsec += elapsed;
      eligibleSince = Number(now);
      if (!playedSent && eligibleWatchMsec >= ELIGIBILITY_MSEC) {
        playedSent = true;
        emit({ name: "product_video_played", watch_time_msec: eligibleWatchMsec });
      }
      if (playedSent) publishProgress();
    }

    function settleWatchTime(reason) {
      var segmentMsec = eligibleWatchMsec - reportedWatchMsec;
      if (segmentMsec < ELIGIBILITY_MSEC) return;
      reportedWatchMsec = eligibleWatchMsec;
      emit({ name: "product_video_watch_time", watch_time_msec: segmentMsec, watch_time_reason: reason });
    }

    function updateEligibility(now) {
      if (isEligible()) {
        if (eligibleSince === null) eligibleSince = Number(now);
      } else if (eligibleSince !== null) {
        accrue(now);
        eligibleSince = null;
      }
    }

    return {
      onVisibility: function (ratio, now) {
        accrue(now);
        visibleRatio = Number(ratio) || 0;
        updateEligibility(now);
      },
      onPlay: function (now) {
        if (ended) return;
        playing = true;
        updateEligibility(now);
      },
      onPause: function (now) {
        accrue(now);
        settleWatchTime("pause");
        playing = false;
        eligibleSince = null;
      },
      onPageHidden: function (now, reason) {
        accrue(now);
        settleWatchTime(reason || "page_hidden");
        visibleRatio = 0;
        eligibleSince = null;
      },
      onTick: function (now) {
        accrue(now);
        updateEligibility(now);
      },
      onTimeUpdate: function (_positionSeconds, now) {
        this.onTick(now);
      },
      onSeeked: function (_positionSeconds, now) {
        this.onTick(now);
      },
      onEnded: function (now) {
        if (ended) return;
        accrue(now);
        playing = false;
        eligibleSince = null;
        ended = true;
        settleWatchTime("ended");
        if (playedSent) emit({ name: "product_video_ended", watch_time_msec: eligibleWatchMsec });
      },
      getState: function () {
        return { playing: playing, visibleRatio: visibleRatio, eligibleSince: eligibleSince, eligibleWatchMsec: eligibleWatchMsec, playedSent: playedSent, ended: ended };
      },
    };
  }

  var api = {
    createVideoSession: createVideoSession,
    createMediaRegistry: createMediaRegistry,
    normalizeMediaUrl: normalizeMediaUrl,
    logicalMediaKey: logicalMediaKey,
  };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  root.SNDTCProductMediaCore = api;
})(typeof globalThis !== "undefined" ? globalThis : this);
